/**
 * Lifecycle of the "Questions about Trovve?" introduction (design: Trovve.dc.html `hlp`).
 *  - unknown:  not asked yet this page load (GetHelpAppService.BeginIntro runs on the first My Day load).
 *  - eligible: the banner is up on My Day (the user's first session with the introduction).
 *  - flying:   the banner collapses and its ? icon flies to the main-menu Get help.
 *  - landed:   Get help has just arrived in the menu and is highlighted for 2 s; the meeting slot is restored.
 *  - done:     steady state — Get help in the main menu, no banner, now and on every later login.
 */
export type GetHelpPhase = 'unknown' | 'eligible' | 'flying' | 'landed' | 'done';

/** Views of the "How can we help?" callout (design: home / ask / setup / sent). */
export type GetHelpView = 'home' | 'ask' | 'setup' | 'sent';

/** Which draft the callout just opened in the user's mail app: a question, or a setup-help request. */
export type GetHelpSentKind = 'question' | 'setup';

/** Mirrors BPC.Vineforce.GetHelp.Dto.BeginGetHelpIntroInput. */
export interface BeginGetHelpIntroInput {
    sessionId: string;
}

/** Mirrors BPC.Vineforce.GetHelp.Dto.GetHelpIntroDto. */
export interface GetHelpIntroDto {
    showBanner: boolean;
    isExistingUser: boolean;
}

/**
 * The callout the user was working in, kept for the rest of the session so leaving My Day (or refreshing) and coming
 * back restores it rather than discarding their question.
 */
export interface GetHelpDraft {
    calloutOpen: boolean;
    view: GetHelpView;
    question: string;
}

/** Start point and travel of the ? icon's flight, in viewport px (design `hlpFly`). */
export interface GetHelpFlight {
    x: number;
    y: number;
    dx: number;
    dy: number;
}

/** The common questions offered under the textarea (design `HLP_QUICK`); the first three show until "More questions". */
export const GET_HELP_QUICK_QUESTIONS: readonly string[] = [
    'How does Trovve work with Clio?',
    'What can Trovve access in Microsoft 365?',
    'Can I change what Trovve found?',
    'How much does Trovve cost?',
    'How does email matching work?',
];
